import type { IApiResponse } from '../types/drsProps';
export class HttpError extends Error {
    status: number;
    response: Response;

    constructor(response: Response) {
        super(`HTTP error ${response.status}`);
        this.status = response.status;
        this.response = response;
    }
}

export class Fetch {
    private apiLink: string;
    private readonly isMobile: boolean | undefined;

    private datasheetEndpoint = 'datasheetretrieval/GetDataSheet';
    constructor(apiLink: string) {
        this.apiLink = apiLink;
        this.handleError.bind(this);
    }

    private async fetchJson<T>(url: string, timeoutMs = 5000, init?: RequestInit): Promise<T> {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), timeoutMs);
        try {
            const response = await fetch(url, { signal: controller.signal, ...init });
            if (!response.ok) throw new HttpError(response);
            return response.json() as Promise<T>;
        } finally {
            clearTimeout(timer);
        }
    }

    private handleError(error: Error | HttpError): null {
        const errorMsg = error instanceof HttpError ? error.message : `${error.name}: ${error.message}`;
        const errorStack = error instanceof HttpError ? `status: ${error.status}` : error.stack;
        // eslint-disable-next-line no-console
        console.warn(`ajax fetch failed with "${errorMsg}". Full error:\n${errorStack}`);
        return null;
    }

    public fetch(
        salesArticleNo: string,
        colorCode: string,
        masterArticleNo: number,
        applicationName: string
    ): Promise<IApiResponse | null> {
        const apiUrl = this.apiLink + this.datasheetEndpoint;
        const requestUrl = new URL(apiUrl);

        // Append all query parameters from the current browser URL
        if (typeof window !== 'undefined') {
            const currentUrl = new URL(window.location.href);

            currentUrl.searchParams.forEach((value, key) => {
                requestUrl.searchParams.append(key, value);
            });
        }

        requestUrl.searchParams.set('salesArticleNo', salesArticleNo);
        requestUrl.searchParams.set('colorCode', colorCode);
        requestUrl.searchParams.set('masterArticleNo', masterArticleNo.toString());
        requestUrl.searchParams.set('applicationName', applicationName);

        return this.fetchJson<IApiResponse>(requestUrl.toString(), 3500)
            .catch(error => this.handleError(error));
    }
}
